import Config from '@configs/Environments';
import { PublicRouting, SecureRouting } from '@pages/Routings';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';

const Routing = () => {
    return (
        <BrowserRouter>
            {Config.OKTA_AUTH_MODE ? <SecureRouting /> : <PublicRouting />}
        </BrowserRouter>
    );
};

export default Routing;